module.exports = __webpack_public_path__ + "img/high.6be1750d.png";